import React from 'react';
import {ItemPresenter} from "../ItemPresenter";

const className = "pigsteakmeat";

function GIPigSteakMeat() {
  return (
    <ItemPresenter imagePath={`/images/gameItems/${className}.png`} tooltipText={className} />
  );
}

export default GIPigSteakMeat;